<script>
export default {
  props: {
    status: { type: String, default: 'pendente' },
  },
  computed: {
    config() {
      const map = {
        open:            { label: 'Em aberto',      cls: 'badge-soft-warning'   },
        pending:         { label: 'Pendente',       cls: 'badge-soft-secondary' },
        approved:        { label: 'Aprovado',       cls: 'badge-soft-success'   },
        ineligible:      { label: 'Inelegível',     cls: 'badge-soft-danger'    },
        nonconformities: { label: 'Triagem',        cls: 'badge-soft-warning'   },
        pendente:        { label: 'Pendente',       cls: 'badge-soft-secondary' },
        enviado:         { label: 'Enviado',        cls: 'badge-soft-info'      },
        aprovado:        { label: 'Aprovado',       cls: 'badge-soft-success'   },
        reprovado:       { label: 'Reprovado',      cls: 'badge-soft-danger'    },
        assinado:        { label: 'Assinado',       cls: 'badge-soft-success'   },
        aguardando:      { label: 'Aguardando',     cls: 'badge-soft-warning'   },
        completo:        { label: 'Completo',       cls: 'badge-soft-success'   },
        em_andamento:    { label: 'Em andamento',   cls: 'badge-soft-warning'   },
        cancelado:       { label: 'Cancelado',      cls: 'badge-soft-danger'    },
      }
      return map[this.status] || map['pendente']
    },
  },
}
</script>

<template>
  <span class="badge font-size-12 text-uppercase" :class="config.cls">{{ config.label }}</span>
</template>
